import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual, isEmpty } from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import DateTimePicker from 'react-datetime';

class DateTime extends Component {
	constructor(props) {
		super(props);
		this.debounceTimeout = null;
		this.debounceFunction = null;
		this.state = {
			value : props.value,
		};
	}

	UNSAFE_componentWillReceiveProps = ({ value }) => {
		const lastState = this.state;

		if (!isEqual(value, lastState.value)) this.setState({ value });
	}

	shouldComponentUpdate = ({ rawErrors }, { value }) => {
		const lastState = this.state;
		const lastProps = this.props;

		return (
			!isEqual(value, lastState.value)
		|| !isEqual(rawErrors, lastProps.rawErrors)
		);
	}

	onChange = (data) => {
		this.setState({ value : data.format('M/D/YYYY') });

		/**
		 * Clear debounceTimeout to prevent updating the Store
		 * multiple times using the JS native function
		 * clearTimeout
		 */
		if (this.debounceTimeout !== null) clearTimeout(this.debounceTimeout);

		this.debounceFunction = () => {
			const { onChange } = this.props;

			onChange(data.format('M/D/YYYY'));
		};
		this.debounceTimeout = setTimeout(this.debounceFunction, 100);
	}

	render() {
		const {
			options : {
				label,
				wrapperClassName,
				inputClassName,
				large,
				selectClassName,
				labelFont,
			},
			rawErrors,
		} = this.props;
		const { value } = this.state;
		return (
			<div className={wrapperClassName}>
				<FormGroup
					bsSize={large ? 'lg' : undefined}
					className={classNames(inputClassName, { 'has-error' : !isEmpty(rawErrors) })}
				>
					<ControlLabel className={classNames(`${labelFont} font-size-15 color-gray-mine-shaft`,
						{ 'color-pink-brink' : !isEmpty(rawErrors) })}
					>
						{ label }
					</ControlLabel>
					<DateTimePicker
						closeOnSelect
						dateFormat="M/D/YYYY"
						timeFormat={false}
						value={moment(value, 'M/D/YYYY')}
						onChange={this.onChange}
						className={selectClassName}
						inputProps={{ readOnly : true }}
					/>
				</FormGroup>
			</div>
		);
	}
}

DateTime.propTypes = {
	onChange  : PropTypes.func.isRequired,
	value     : PropTypes.string,
	rawErrors : PropTypes.array,
	options   : PropTypes.shape({
		label               : PropTypes.string,
		selectClassName     : PropTypes.string,
		wrapperClassName    : PropTypes.string,
		inputClassName      : PropTypes.string,
		inputGroupClassName : PropTypes.string,
		large               : PropTypes.bool,
		labelFont           : PropTypes.string,
	}),
};

DateTime.defaultProps = {
	value     : null,
	rawErrors : [],
	options   : {
		label               : '',
		selectClassName     : 'signup-select',
		wrapperClassName    : '',
		inputClassName      : '',
		inputGroupClassName : '',
		large               : true,
		labelFont           : 'font-regular',
	},
};

export default DateTime;
